import { render, staticRenderFns } from "./SignaturesList.vue?vue&type=template&id=16982f80&scoped=true"
import script from "./SignaturesList.vue?vue&type=script&lang=js"
export * from "./SignaturesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16982f80",
  null
  
)

export default component.exports